import { FormControlValidator } from '../use-form-control';

export function EqualsValidator(comparison: () => string | number, customMsg?: string): FormControlValidator {
  return (val) => {
    if (val && val === comparison()) {
      return {
        valid: true
      };
    }
    return { valid: false, errors: [ { msg: customMsg || '' }] };
  };
}